import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarMui = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 24,
	viewBox: "0 0 22 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18.5 3H17V0.75C17 0.375 16.625 0 16.25 0C15.8281 0 15.5 0.375 15.5 0.75V3H6.5V0.75C6.5 0.375 6.125 0 5.75 0C5.32812 0 5 0.375 5 0.75V3H3.5C1.8125 3 0.5 4.35938 0.5 6V21C0.5 22.6875 1.8125 24 3.5 24H18.5C20.1406 24 21.5 22.6875 21.5 21V6C21.5 4.35938 20.1406 3 18.5 3ZM20 21C20 21.8438 19.2969 22.5 18.5 22.5H3.5C2.65625 22.5 2 21.8438 2 21V9H20V21ZM20 7.5H2V6C2 5.20312 2.65625 4.5 3.5 4.5H18.5C19.2969 4.5 20 5.20312 20 6V7.5ZM8.9375 19.3125C9.07812 19.4531 9.26562 19.5 9.5 19.5C9.6875 19.5 9.875 19.4531 10.0156 19.3125L16.0156 13.3125C16.2969 13.0312 16.2969 12.5156 16.0156 12.2344C15.7344 11.9531 15.2188 11.9531 14.9375 12.2344L9.5 17.7188L7.01562 15.2344C6.73438 14.9531 6.21875 14.9531 5.9375 15.2344C5.65625 15.5156 5.65625 16.0312 5.9375 16.3125L8.9375 19.3125Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgCalendarMui);
export { ForwardRef as ReactComponent };
